import { FC, memo } from "react";
import ReactMarkdown, { Components } from "react-markdown";
import remarkGfm from "remark-gfm";

const components: Components = {
};

export const MarkdownText: FC<any> = memo((props) => {
  // Handle different prop structures
  const text = props?.part?.text || props?.text || props?.children;

  if (!text || typeof text !== "string") {
    return null;
  }

  return (
    <div className="prose dark:prose-invert max-w-none break-words prose-p:leading-relaxed prose-pre:p-0">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {text}
      </ReactMarkdown>
    </div>
  );
});

MarkdownText.displayName = "MarkdownText";
